import appLogo from "assets/images/xero_logo.svg";
import AppFrame from "components/AppFrame";
import JobberCallback from "pages/JobberCallback";
import JobberXeroStep1 from "pages/Jobber-Xero/Step1";
import JobberXeroStep2 from "pages/Jobber-Xero/Step2";
import JobberXeroStep3 from "pages/Jobber-Xero/Step3";
import XeroCallback from "pages/XeroCallback";
import XeroJobberStep1 from "pages/Xero-Jobber/Step1";
import XeroJobberStep2 from "pages/Xero-Jobber/Step2";
import XeroJobberStep3 from "pages/Xero-Jobber/Step3";
import Settings from "pages/Settings/Settings";
import Error from "pages/Error";
import {
  Navigate,
  Outlet,
  Route,
  Routes as ReactRouterRoutes,
} from "react-router-dom";

const Routes = () => {
  return (
    <ReactRouterRoutes>
      <Route element={<ProtectedRoutes />}>
        <Route element={<AppFrame logo={appLogo} />}>
          <Route index element={<Navigate to="jobber-xero-step1" />} />
          <Route path="jobber-xero-step1" element={<JobberXeroStep1 />} />
          <Route path="jobber-xero-step2" element={<JobberXeroStep2 />} />
          <Route path="jobber-xero-step3" element={<JobberXeroStep3 />} />
          <Route path="xero-jobber-step1" element={<XeroJobberStep1 />} />
          <Route path="xero-jobber-step2" element={<XeroJobberStep2 />} />
          <Route path="xero-jobber-step3" element={<XeroJobberStep3 />} />
          <Route path="error" element={<Error />} />
          <Route path="settings" element={<Settings />} handle={{ routeTitle: "Settings" }} />
        </Route>
      </Route>
      <Route path="jobber/callback" element={<JobberCallback />} />
      <Route path="xero/callback" element={<XeroCallback />} />
    </ReactRouterRoutes>
  );
};

const ProtectedRoutes = () => {
  return <Outlet />;
};

export default Routes;
